import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {useOnboardingStore} from '@toolify/client/src/modules/onboarding/stores/useOnboardingStore'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {restoreWorkspaceContext} from './restoreWorkspaceContext'

function isInvitationDestination(to: RouteLocationNormalized): boolean {
  if(to.name === RouteName.Invitation) {
    return true
  }
  if(to.path.includes('/invitation/')) {
    return true
  }
  const continueQuery = to.query.continue
  const continueValue = Array.isArray(continueQuery) ? continueQuery.join('') : (continueQuery ?? '')
  if(!continueValue) {
    return false
  }
  let decodedValue: string
  try {
    decodedValue = decodeURIComponent(continueValue)
  } catch {
    decodedValue = continueValue
  }
  return decodedValue.includes('/invitation/')
}

export function ensureOnboardingCompleteRouterHookFactory(pinia: Pinia) {
  return async function ensureOnboardingCompleteRouterHook(to: RouteLocationNormalized) {
    const authStore = useAuthStore(pinia)
    if(!authStore.isLoggedIn) {
      return
    }

    if(to.name === RouteName.Onboarding) {
      return restoreWorkspaceContext(pinia)
    }

    const workspaceStore = useWorkspaceStore(pinia)
    const currentWorkspaceId = workspaceStore.currentWorkspace?.id
    if(!currentWorkspaceId) {
      return
    }

    if(isInvitationDestination(to)) {
      return
    }

    const onboardingStore = useOnboardingStore(pinia)
    onboardingStore.recomputeFromStores()

    if(onboardingStore.isKnown && !onboardingStore.isComplete) {
      return {
        name: RouteName.Onboarding,
      }
    }
  }
}
